// libs/toolkit/src/lib/templates/base/button/button.component.ts
import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  ViewChild
} from '@angular/core';

@Component({
  selector: 'jmkw-button',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {
  @HostBinding('attr.id') get hostId(): string | undefined {
    return this.id;
  }

  @ViewChild('button', { static: false, read: ElementRef<HTMLButtonElement> })
  buttonRef!: ElementRef<HTMLButtonElement>;

  @Input() id?: string;
  @Input() iconName?: string;
  @Input() fontSizeRem = 1.4;
  @Input() buttonText?: string;
  @Input() automationKey?: string;
  @Input() disabled?: boolean;
  @Input() tooltipText = '';
  @Input() active = false;
  @Input() hover = false;

  @Output() onClick = new EventEmitter<MouseEvent>();

  onClickHandler(e: MouseEvent): void {
    if (this.disabled) {
      return;
    }
    this.onClick.emit(e);
  }
}
